module.exports = __webpack_public_path__ + "img/IMG_6981.db2eda8d.webp";